import { Outlet } from 'react-router';

import { FoFooter } from './FoFooter';
import { FoHeader } from './FoHeader';
import { useFoTheme } from './useFoTheme';

/** FO 기본 레이아웃 — 풀셸(Header + Footer). 랜딩·법무 등 공개 콘텐츠 페이지용. 본문은 Outlet. */
export function FoDefaultLayout() {
  useFoTheme();
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <FoHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <FoFooter />
    </div>
  );
}
